<template>
    <UDropdown 
        :items="items" 
        :popper="{ arrow: true, placement: 'top' }" 
        :ui="{ 
            width: 'w-40',
            padding: 'p-1.5 space-y-1.5',
            item: {
                base: 'overflow-hidden !text-white',
                padding: 'p-0'
            }
        }">
        <UButton
            :ui="{ rounded: 'rounded-full' }"
            :loading="holding"
            label="Put On-Hold"
            icon="i-ph-pause-circle-duotone"
            size="lg"
            class="dark:text-white dark:bg-amber-500 dark:hover:bg-amber-600"
        />

        <template #item="{ item }">
            <div :class="item.color" class="w-full flex items-center py-2 px-2.5 space-x-2.5">
                <span class="truncate font-medium">{{ item.label }}</span>
            </div>
        </template>
    </UDropdown>
</template>

<script setup lang="ts">
import { CallStatus, type Call } from '~/types/call'

const emit = defineEmits<{
    'confirm': [void]
}>()

const props = defineProps<{
    call: Call
}>()

const client = useSupabaseClient()
const auth = useAuthStore()
const toast = useToast()

const holding = ref<boolean>(false)

const items = [[
    {
        label: 'P1 (Highest)',
        color: 'bg-red-600 hover:bg-red-500',
        click: () => onConfirm('1'),
    },
    {
        label: 'P2 (High)',
        color: 'bg-orange-500 hover:bg-orange-400',
        click: () => onConfirm('2'),
    },
    {
        label: 'P3 (Moderate)',
        color: 'bg-blue-500 hover:bg-blue-400',
        click: () => onConfirm('3'),
    },
    {
        label: 'P4 (Low)',
        color: 'bg-green-500 hover:bg-green-400',
        click: () => onConfirm('4'),
    },
    {
        label: 'P5 (Lowest)',
        color: 'bg-gray-600 hover:bg-gray-500',
        click: () => onConfirm('5'),
    }
]]

async function onConfirm(priority: string) {
    if (props.call?.id) {
        holding.value = true

        try {
            const { error } = await client.from('calls')
                .update({
                    transferrer_id: auth.user?.id,
                    user_id: null,
                    status: CallStatus.onHold,
                    on_hold_at: new Date().toISOString(),
                    metadata: {
                        ...props.call.metadata,
                        priority
                    }
                } as never)
                .eq('id', props.call.id)

            if (error) {
                throw error
            }

            toast.add({
                title: 'Call is now on-hold!',
                color: 'green',
                icon: 'i-ph-check-circle-duotone'
            })

            emit('confirm')
        } catch (e) {
            toast.add({
                title: 'Could not place call on-hold.',
                color: 'red',
                icon: 'i-ph-warning-duotone'
            })

            console.error('Could not place call on-hold: ' + e)
        } finally {
            holding.value = false
        }
    }
}
</script>